import { render, staticRenderFns } from "./FilePreviewDialog.vue?vue&type=template&id=032fb28f&scoped=true&"
import script from "./FilePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./FilePreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./FilePreviewDialog.vue?vue&type=style&index=0&id=032fb28f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032fb28f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032fb28f')) {
      api.createRecord('032fb28f', component.options)
    } else {
      api.reload('032fb28f', component.options)
    }
    module.hot.accept("./FilePreviewDialog.vue?vue&type=template&id=032fb28f&scoped=true&", function () {
      api.rerender('032fb28f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/detail/components/FilePreviewDialog.vue"
export default component.exports